<div #scroller class="betslip-edit-state__scroller">
    <ng-container *ngIf="betslipUpsellConfig.modulePosition === 'top'; then upselltemplate"></ng-container>

    <ng-container *ngFor="let type of linearBetslipTypesOrder" [ngSwitch]="type">
        <ng-container *ngSwitchCase="betslipTypes.Combo">
            <bs-combo-bet-linear
                *ngIf="isComboModuleActive"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [removeButtonPosition]="removeButtonPosition.None"
                [removeButtonStyle]="removeButtonStyle.Ex"></bs-combo-bet-linear>
        </ng-container>

        <ng-container *ngSwitchCase="betslipTypes.Single">
            <bs-single-bet-linear
                *ngIf="isActive(betslipTypes.Single)"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [removeButtonPosition]="removeButtonPosition.Left"
                [removeButtonStyle]="removeButtonStyle.Ex"></bs-single-bet-linear>
        </ng-container>

        <ng-container *ngSwitchCase="betslipTypes.System">
            <bs-system-bet-linear
                *ngIf="isActive(betslipTypes.System)"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [removeButtonPosition]="removeButtonPosition.None"
                [removeButtonStyle]="removeButtonStyle.Ex"></bs-system-bet-linear>
        </ng-container>

        <ng-container *ngSwitchCase="betslipTypes.Teaser">
            <bs-teaser-bet-linear *ngIf="isActive(betslipTypes.Teaser)" [oddsDisplayFormat]="oddsDisplayFormat"></bs-teaser-bet-linear>
        </ng-container>

        <ng-container *ngSwitchCase="betslipTypes.BetBuilder">
            <bs-linear-bet-builder
                *ngIf="isBetBuilderModuleActive"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [removeButtonStyle]="removeButtonStyle.Ex"></bs-linear-bet-builder>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="betslipUpsellConfig.modulePosition === 'bottom'; then upselltemplate"></ng-container>

    <bs-digital-picks-linear-toolbar></bs-digital-picks-linear-toolbar>
</div>

<ng-template #upselltemplate><bs-upsell-container /></ng-template>
